var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{ref:"anchor",staticClass:"w-input-autocomplete-item",attrs:{"tabindex":"-1"},on:{"click":function($event){$event.preventDefault();return _vm.onClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }